export const ACTION = {
  WIKI_ARTICLES_REQUEST: "WIKI_ARTICLES_REQUEST",
  WIKI_ARTICLES_SUCCESS: "WIKI_ARTICLES_SUCCESS",
  WIKI_ARTICLES_ERROR: "WIKI_ARTICLES_ERROR",
}
